module.exports = __webpack_public_path__ + "img/icon-touch.5366dbd1.png";